class BidNumber {
  data: any
  prefix: string = 'ID'

  constructor(data: any = '') {
    this.data = data
  }

  create(value: number) {
    const date = new Date().toLocaleDateString('en-GB', { month: '2-digit', year: '2-digit' }).replace(/\//g, '')
    return this.prefix + '-' + date + '-' + String(value).padStart(4, '0')
  }

  getFirst() {
    return this.create(1)
  }
}

export default BidNumber
